<template>
  <DataTable :url="api.ACTIONS.PASSENGERS" ref="passengers" :perPage="'25'" :enable-add="false" :enable-edit="false"
    :enable-delete="false" :formatter="formatter" :actions-extra-main="actions" :conditional-action="conditionalActions"
    :initial-url-search-params="typeParams" :fields-hidden-main="[
      'type',
      'approved_at',
      'username',
      'active',
      'establishment_name',
      'birthday',
      'gender',
      'blacklisted_at',
      'account_state'
    ]" :titles="titles" :title='$t("businessPage.pendingTitle")'/>
</template>

<script>
import DataTable from "@/components/monaco/DataTable";
import { formatCompanyTime } from "@/util/companyTime";

export default {
  name: "PendingBusinessAccounts",
 // title: "Pending Business Accounts",
  components: { DataTable },
  computed: {
    titles() {
      return {
        id: this.$t("businessPage.colId"),
        full_name: this.$t("businessPage.colFullName"),
        hotel_name: this.$t("businessPage.colBusinessName"),
        establishment_id: this.$t("businessPage.colAccountNumber"),
        phone_number: this.$t("businessPage.colPhoneNumber"),
        email: this.$t("businessPage.colEmail"),
        created_at: this.$t("businessPage.colCreationDate"),
      };
    },
    typeParams() {
      const params = new URLSearchParams();
      params.append("type", "HOTEL");
      params.append("pending", true);
      return params;
    },
    actions() {
      return {
        edit: {
          title: this.$t("businessPage.viewProfile"),
          icon: "info",
          action: (item) => {
            this.$router.push({ path: `/passengers/${item.id}` });
          },
        },
      };
    },
    conditionalActions() {
      return {};
    },
    formatter() {
      const vm = this;
      return {
        blacklisted_at(val) {
          if (val)
            return `
                        <i class="inactive-mark fa fa-close" style="color:red; font-size:18px"></i>
                        `;
          else
            return `
                         <i class="active-mark fa fa-check" style="color:green; font-size:18px"></i>
                        `;
        },
        gender(val) {
          if (val === null || val === undefined) return "";
          // Backend: 0 = Male, 1 = Female
          return String(val) === "1"
            ? vm.$t("businessPage.genderMale")
            : vm.$t("businessPage.genderFemale");
        },
        birthday(value) {
          if (!value) return "";
          return formatCompanyTime(value, "DD-MM-YYYY");
        },
        created_at(value) {
          if (!value) return "";
          return formatCompanyTime(value, "DD-MM-YYYY  HH:mm");
        },
      };
    },
  },
  methods: {
  },
};
</script>

<style scoped></style>
